import {
  CustomSectionState,
  PeoplePageSourceDerivedSignalSectionAttributes,
} from 'api/custom-section/types';
import { PromptInputFormValues } from '../types';

export const formValuesIntoAttributes = (
  formValues: PromptInputFormValues,
  existingAttributes: PeoplePageSourceDerivedSignalSectionAttributes,
): PeoplePageSourceDerivedSignalSectionAttributes => {
  return {
    ...existingAttributes,
    state: CustomSectionState.Closed,
    title: formValues.title,
    config: {
      sourceSignalConfigurations: formValues.signalConfigurations,
      aiContext: formValues.aiContextChecked ? formValues.aiContext : undefined,
      groupBy: formValues.groupBy,
      generateAs: formValues.generateAs,
      sourcePageTemplates: formValues.sourcePageTemplates,
    },
  };
};
